import React from 'react'
import { Mutation } from "react-apollo";
import { DELETE_BLACK_LIST,GET_BLACK_LIST } from "../../../queries/blackList";
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

function filteredData(selectedRows, blackList, blackLists){
  selectedRows.data.forEach(d => {
    const id = blackLists[d.dataIndex].id;
      blackList = blackList.filter(e => e.id !== id)
    })
  return blackList;
}

class DeleteblackList extends React.Component {
  render(){
    const { selectedRows, blackLists } = this.props;
    console.log(selectedRows);
    return (
      <Mutation
        mutation={DELETE_BLACK_LIST}
        update={(store, { data: { deleteblackList } }) => {
          const { blackList } = store.readQuery({ query: GET_BLACK_LIST });
          store.writeQuery({
            query: GET_BLACK_LIST,
            data: 
            { 
              blackList: filteredData(selectedRows, blackList, blackLists)
            }
          });
        }}
        >
        {deleteblackList => (
          <div>
            <IconButton aria-label="delete" onClick = {
              e => {
                e.preventDefault();
                selectedRows.data.forEach(d => {
                  const id = blackLists[d.dataIndex].id;
                  deleteblackList({ variables: {id: id }})  
                });
                
              }
            }>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </Mutation>
    );
  }
};

export default DeleteblackList;